import React, { useEffect, useState } from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import APInvoices from '../../components/APInvoices';
import ProjectBilling from '../../components/ProjectBilling';
import { getJson } from '../helpers';
import ClaretProjectToolEmbed from './ClaretProjectToolEmbed';

export default function InvoicingPage({ tab = 'owner' }) {
  const { projectVuid } = useParams();
  const [projectName, setProjectName] = useState('');
  const base = `/procore/projects/${projectVuid}/invoicing`;

  useEffect(() => {
    let cancelled = false;
    getJson(`/api/projects/${projectVuid}`)
      .then((project) => {
        if (!cancelled && project?.project_name) setProjectName(project.project_name);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [projectVuid]);

  return (
    <div className="pc-page">
      <div className="pc-crumb">
        <Link to="/procore">Portfolio</Link>
        {' / '}
        <Link to={`/procore/projects/${projectVuid}`}>{projectName || 'Project'}</Link>
        {' / '}
        Invoicing
      </div>
      <div className="pc-title-row">
        <h1>Invoicing</h1>
      </div>
      <div className="pc-subnav">
        <NavLink to={`${base}?project=${projectVuid}`} end className={({ isActive }) => (isActive || tab === 'owner' ? 'pc-subnav-active' : '')}>
          Owner Billings
        </NavLink>
        <NavLink to={`${base}/subcontractor?project=${projectVuid}`}>Subcontractor Invoices</NavLink>
      </div>
      {tab === 'ap' ? (
        <ClaretProjectToolEmbed
          title="Subcontractor Invoices"
          projectVuid={projectVuid}
          createLabel="Create Invoice"
          hideChrome
          syncKind="invoice"
        >
          <div className="pc-invoice-list">
            <APInvoices />
          </div>
        </ClaretProjectToolEmbed>
      ) : (
        <ClaretProjectToolEmbed
          title="Owner Billings"
          projectVuid={projectVuid}
          createLabel="Create Billing"
          hideChrome
          syncKind="owner-billing"
        >
          <ProjectBilling />
        </ClaretProjectToolEmbed>
      )}
    </div>
  );
}
